import {
  GET_REQUEST_LIST,
  GET_REQUEST_LIST_SUCCESS,
  GET_REQUEST_LIST_FAILURE,
} from 'store/requestList/requestListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const requestListDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUEST_LIST:
      return { ...state, loading: true };
    case GET_REQUEST_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_REQUEST_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default requestListDataReducer;
